import { Injectable, Inject } from '@angular/core';
import { Http, URLSearchParams, Headers, Response, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';

import { ApiConfig } from 'base-api-service';
import { CommonUtil } from 'base-api-service';
import { AuthService } from './auth.service';


export class SkypAuthService  implements AuthService {

  constructor() {}

  login(username: string, password: string) {
    // DO nothing
  }

  logout() {
    // DO nothing
  }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
